import styled from "styled-components";

const styleOfAutomate = { position: "absolute", right: "140px", top: "4.5vh" };

const AutomateCss = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: var(--ASH, #676879);
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  background: var(--CLOUD, #fcfdfe);
  min-width: min-content;
  padding-bottom: 8px;

  > .headerOfEditModal {
    font-size: 14px;
  }
  .btnGroupAuto {
    display: flex;
    justify-content: end;
    gap: 16px;
    padding: 0 24px;
    button {
      padding: 4px 16px;
      height: auto;
    }
    .reset {
      background: #cf324a;
      color: var(--Cloud, #fcfdfe);
    }
  }
`;

const AutomateContentCss = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: var(--ASH, #676879);
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  background: var(--CLOUD, #fcfdfe);
  padding: 0 24px;

  .field {
    line-height: 1.2;
    height: 32px;
    padding: 8px 4px 8px 11px;
    border-radius: 4px;
    border: 1px solid var(--LIGHT-ASH, #b9b9c6);
    width: 190px;
    outline: none;
    color: var(--ASH, #676879);
    &::-webkit-calendar-picker-indicator {
      cursor: pointer;
    }
  }
  .period {
    width: 190px;
  }
  .options {
    display: flex;
    flex-direction: column;
    gap: 18px;
    label {
      display: flex;
      flex-direction: row;
      gap: 8px;
    }
  }
  .dailyOptions {
    width: 114px;
  }
  .valueForOption.dayText {
    width: auto !important;
    position: relative;
    bottom: 5px;
  }
  .inputText {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    input {
      height: 32px;
      width: 38px;
      text-align: center;
      padding: 5px 0;
      border-radius: 4px;
      border: 1px solid var(--LIGHT-ASH, #b9b9c6);
      background: var(--CLOUD, #fcfdfe);
      outline: none;
    }
  }
  > .rangeOfRecurrenceCont {
    > .rangeOfRecurrenceHead {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    > .rangeContainer {
      display: flex;
      gap: 24px;

      .startDate,
      .endDate {
        display: flex;
        flex-direction: column;
        input {
          text-transform: uppercase;
        }
      }
      > .recOptions {
        position: relative;
        top: 29px;
      }
      > .valueForOption {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
    }
  }

  > .sendTime {
    display: flex;
    flex-direction: column;
  }

  > .pattern {
    .patternHead {
      margin-bottom: 8px;
    }
    .recPattern {
      display: flex;

      > .optionsForPattern {
        .recHeader {
          margin-bottom: 12px;
        }
      }

      .valueForOption,
      .period {
        width: 214px;
      }
    }
  }

  .recipientList {
    padding: 4px 0;
    cursor: pointer;

    color: var(--BLUE, #2060ea);
    text-align: center;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: auto;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }
`;

const DateInputDiv = styled.div`
  width: ${props => props.width ?? "100%"};
  .ant-picker {
    border-radius: 4px;
    border: 1px solid var(--LIGHT-ASH, #b9b9c6);
    height: 32px;
    font-family: Inter;
    width: ${props => props.width ?? "100%"};
    .ant-picker-suffix {
      align-items: center;
      cursor: pointer;
      display: flex;
      pointer-events: auto;
    }
  }
  .ant-picker.ant-picker-disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: transparent;
  }
  input {
    font-size: 14px !important;
    color: var(--ASH, #676879) !important;
    line-height: 1.2 !important;

    &::placeholder {
      color: var(--ASH, #676879) !important;
      opacity: 1;
    }
  }
`;

export { AutomateContentCss, AutomateCss, styleOfAutomate, DateInputDiv };
